<p-autocomplete
  [ngModel]="query()"
  (ngModelChange)="onQueryChange($event)"
  [suggestions]="suggestions()"
  (completeMethod)="search($event)"
  (onSelect)="select($event)"
  [placeholder]="placeholder()"
  [disabled]="disabled()"
  [showClear]="true"
  [showEmptyMessage]="true"
  optionLabel="label"
>
  <ng-template #empty>
    <app-autocomplete-empty-message
      [loading]="loading()"
      text="Place not found"
    ></app-autocomplete-empty-message>
  </ng-template>
</p-autocomplete>
